import React from "react";
import {CONFIG} from "../../util/config";
import styles from './Simulations.module.scss'
import {Spin} from "antd";
import {ModulePermission} from "../../actions/api";
import {useParams} from "react-router-dom";
import {useHasResources} from "../../util/resources";
import IframeResizer from 'iframe-resizer-react';
import {Helmet} from 'react-helmet'

export const Simulations = () => {

    const {simulationCode} = useParams()
    const hasResources = useHasResources(ModulePermission.SIMULATIONS, simulationCode)

    if (hasResources === undefined) {
        return <Spin size="large"/>
    }

    if (!hasResources) {
        return null
    }

    const getSimulationTitle = (resourceCode: string) => {
        if(simulationCode === 'simulations_biogen'){
            return 'Simulations - Biogen - Ophthalmology Simulation Model'
        }
    }

    return <>

        <Helmet>
            <title>{getSimulationTitle(simulationCode)}</title>
        </Helmet>
        {/* Iframe loaded from simulations-ui repository */}
        <IframeResizer
            className={styles.simulations}
            title="Simulations Application"
            src={`${CONFIG.hostName}/simulations/${simulationCode}`}
            style={{"overflow": "hidden", "height": "100%", "width": "100%"}}
            scrolling={false}
            resizeFrom={'child'}
        />

    </>
}